/* Delivery check on product pages: pincode -> /apps/sla/check -> "Get it By ..." (+ free-delivery timer, store card).
   One module for main-product.liquid ("main") and snippets/pincode_service_opera.liquid ("opera");
   config comes from snippets/dfx-delivery.liquid.

   - The request is always the variant + quantity selected right now: price.liquid prints the variant fields
     (#selected_variant_sku, #selected_variant_simple_sku, L1/L5/L6) and dfx-pdp.js rewrites them on every
     size / quantity change. combo_sku = variant simple_sku (product-level fallback).
   - A check runs on: page load (saved pincode; else location, main pages), Check button / Enter, a size or
     quantity change (only when a pincode is showing and the request really changed), and a pincode chosen
     anywhere else (lead popup via duroflex:pincode_set, the store drawer via DfxDelivery.check).
   - Only the newest answer is drawn, and each answer redraws the whole delivery area, so nothing from an
     earlier answer (timer, store card, date) is left behind.
   - Lead / brochure popups build their request with DfxDelivery.request(pin). */
(function () {
  'use strict';
  var W = window, D = document;
  var cfgEl = D.getElementById('dfx-delivery-config');
  if (!cfgEl || W.DfxDelivery) return;
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
  var OPERA = cfg.mode === 'opera';
  var SLA_URL = '/apps/sla/check';
  var LOG_URL = 'https://dfxstorelocatorapi.azurewebsites.net/api/PinCodeETA/PinCodeDetails';
  var LOG_AUTH = 'Basic REZYLlBpbmNvZGUuVXNlcjpEdXJvZmxleEAxMjMj'; // same credentials the old inline checkers sent
  var PIN_KEY = 'duroflex_pincode';
  var HIDE = 'hide_pincode_block', HIDE_OPERA = 'hide_custom_options';

  function all(sel) { return [].slice.call(D.querySelectorAll(sel)); }
  function show(sel, on, cls) { all(sel).forEach(function (el) { el.classList.toggle(cls || HIDE, !on); }); }
  function html(sel, h) { all(sel).forEach(function (el) { el.innerHTML = h; }); }
  function text(sel, t) { all(sel).forEach(function (el) { el.textContent = t; }); }
  function attr(sel, n, v) { all(sel).forEach(function (el) { el.setAttribute(n, v); }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
  function cleanPin(p) { p = String(p || '').replace(/\D/g, '').slice(0, 6); return p.length === 6 ? p : ''; }
  function emit(name, detail) { try { W.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch (e) {} }
  function input() { return D.getElementById('pincode'); }

  // ---- the request: the variant selected right now ----
  function field(id) {
    var box = cfg.price && D.getElementById(cfg.price);
    var el = (box && box.querySelector('#' + id)) || D.getElementById(id);
    return el ? el.textContent.trim() : '';
  }
  function pageQty() {
    if (OPERA) return '1'; // Opera always checked one unit
    var q = D.querySelector('.quantity__input[name="quantity"]') || D.querySelector('input[name="quantity"]');
    return String((q && q.value) || '1');
  }
  function request(pin, o) {
    o = o || {};
    return {
      l1_product_group: field('variant_block_product_group_l') || 'ALL',
      l5_product_group: field('variant_block_product_group_l5') || (OPERA ? '123' : ''),
      l6_product_group: field('variant_block_product_group_l6') || (OPERA ? '223' : ''),
      pincode: String(pin),
      qty: o.qty || pageQty(),
      sku: field('selected_variant_sku'),
      combo_sku: field('selected_variant_simple_sku')
    };
  }

  function post(url, body, headers) {
    return fetch(url, {
      method: 'POST',
      headers: Object.assign({ 'Content-Type': 'application/json' }, headers || {}),
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); });
  }

  // ---- saved pincode (shared with the popups: localStorage duroflex_pincode) ----
  function savedPin() {
    var pin = '';
    try { pin = W.localStorage.getItem(PIN_KEY) || ''; } catch (e) {}
    if (!pin) { // legacy visitors only have the user_pincode cookie; migrate it once
      var m = D.cookie.match(/(?:^|;\s*)user_pincode=(\d{6})/);
      if (m) { pin = m[1]; savePin(pin); }
    }
    return cleanPin(pin);
  }
  function savePin(pin) { try { W.localStorage.setItem(PIN_KEY, pin); } catch (e) {} }

  // ---- free-delivery countdown (orders before 15:00) ----
  var timer = null;
  function stopTimer() { if (timer) { clearInterval(timer); timer = null; } text('.pincode_timer', ''); }
  function startTimer() {
    stopTimer();
    var end = new Date(); end.setHours(15, 0, 0, 0);
    var endAt = end.getTime();
    if (Date.now() >= endAt) return;
    var two = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var left = endAt - Date.now();
      if (left < 0) return stopTimer();
      text('.pincode_timer', two(Math.floor(left / 3600000)) + ':' + two(Math.floor((left % 3600000) / 60000)) + ':' + two(Math.floor((left % 60000) / 1000)));
    };
    tick(); timer = setInterval(tick, 1000);
  }

  // ---- drawing: each answer redraws everything it owns ----
  var MAIN = {
    reset: function () {
      html('#pincodechecked', '');
      text('.pincode_error_msg .error_msg', ''); show('.pincode_error_msg', false);
      show('.checked_pincode_delivery_block', false); show('.check_delivery_block', true);
      text('#pincode_checked_title', ''); show('#pincode_checked_title', false); show('#pincode_check_title', true);
      show('#delivery-status', false);
      text('.pincode_success_msg .delivery_date', ''); show('.pincode_success_msg', false); stopTimer();
      show('.store_information_pincode', false);
      html('.store_locator_api_block', ''); show('.store_locator_api_block', false);
      show('.arrives-text', true);
    },
    success: function (pin, r) {
      html('#pincodechecked', '<span>' + esc(pin) + ' :</span> ' + esc(r.city));
      text('#pincode_checked_title', 'Get it By ' + (r.estimated_delivery_date || ''));
      show('#pincode_checked_title', true); show('#pincode_check_title', false); show('#delivery-status', true);
      show('.checked_pincode_delivery_block', true); show('.check_delivery_block', false);
      show('.pincode_error_msg', false); show('.arrives-text', false);
      var tomorrow = Number(r.data) <= 1;
      text('.pincode_success_msg .delivery_date', tomorrow ? 'Tomorrow' : '');
      show('.pincode_success_msg', tomorrow);
      if (tomorrow) startTimer(); else stopTimer();
      var store = !!r.Storename;
      if (store) {
        attr('.checked_store_img img', 'src', r.Imageurl || '');
        text('.checked_store_addrerss .checked_store_name', r.Storename);
        text('.checked_store_addrerss .checked_store_address', r.Address || '');
        text('.opening_time .timing_block', r.Opentime || '');
        attr('.checked_direction a', 'href', r.Mapurl || '#');
        attr('.checked_callstore a', 'href', 'tel:' + (r.SPOCPhone || ''));
      }
      show('.store_information_pincode', store);
      text('.cart_pincode_show_block .cart_pincode_city', pin + ', ' + (r.city || '')); // cart drawer header
      all('.cart_pincode_header_block').forEach(function (el) { el.classList.remove('cart_pincodehidden'); });
      // popup-store-drawer.js renders "Delivery by / Explore N stores" from this
      emit('duroflex:pincode-checked', { pincode: pin, eta: r.estimated_delivery_date || '', city: r.city || '' });
    },
    failure: function (pin, msg) {
      MAIN.reset();
      var i = input(); if (i) i.value = pin;
      show('.arrives-text', false);
      text('.pincode_error_msg .error_msg', msg || 'Delivery is not available in your area!');
      show('.pincode_error_msg', true);
      emit('duroflex:pincode-cleared', { pincode: pin, reason: 'unserviceable' });
    }
  };
  var OPERA_UI = {
    reset: function () {
      html('#pincodechecked', '');
      show('.pincode_error_msg', false);
      show('.checked_pincode_delivery_block', false); show('.check_delivery_block', true);
      show('.pincode_success_msg', false);
      show('#check_service_opera_btn', true, HIDE_OPERA); show('.form_btn_block', false, HIDE_OPERA);
      text('#pincode_checked_title', ''); show('#pincode_checked_title', false);
      stopTimer(); show('.pincode_free_delivery_msg', false);
    },
    success: function (pin, r) {
      html('#pincodechecked', '<span>' + esc(pin) + ' :</span> ' + esc(r.city));
      show('.checked_pincode_delivery_block', true); show('.check_delivery_block', false);
      text('#pincode_checked_title', 'Get it By ' + (r.estimated_delivery_date || ''));
      show('#pincode_checked_title', true);
      show('#check_service_opera_btn', false, HIDE_OPERA); show('.form_btn_block', true, HIDE_OPERA);
      show('.pincode_error_msg', false);
      var tomorrow = Number(r.data) <= 1;
      text('.pincode_free_delivery_msg .delivery_date', tomorrow ? 'Tomorrow' : '');
      show('.pincode_free_delivery_msg', tomorrow);
      if (tomorrow) startTimer(); else stopTimer();
      // Opera prints the date itself, so the store-drawer unit gets no ETA line (as before)
      emit('duroflex:pincode-checked', { pincode: pin, eta: '', city: r.city || '' });
    },
    failure: function (pin) { // the error text is fixed in the Opera markup
      html('#pincodechecked', '<span class="non_service">' + esc(pin) + ' </span> ');
      show('.checked_pincode_delivery_block', true); show('.check_delivery_block', false);
      text('#pincode_checked_title', ''); show('#pincode_checked_title', false);
      show('#check_service_opera_btn', true, HIDE_OPERA); show('.form_btn_block', false, HIDE_OPERA);
      show('.pincode_error_msg', true);
      stopTimer(); show('.pincode_free_delivery_msg', false);
      emit('duroflex:pincode-cleared', { pincode: pin, reason: 'unserviceable' });
    }
  };
  var UI = OPERA ? OPERA_UI : MAIN;

  // Opera: a manual Check opens the result modal (except on the products that opt out)
  function openModal() {
    var m = D.getElementById('pincode_response_modal'), o = D.querySelector('.pincode_service_overlay_block');
    if (m) m.classList.add('opened');
    if (o) o.classList.add('opened');
  }
  function closeModal() {
    var m = D.getElementById('pincode_response_modal'), o = D.querySelector('.pincode_service_overlay_block');
    if (m) m.classList.remove('opened');
    if (o) o.classList.remove('opened');
  }

  // ---- the analytics log of every answered check (as the old checkers did) ----
  function log(req, r, ok) {
    var nitro = W.nitro || {};
    post(LOG_URL, {
      sku: req.sku, pincode: req.pincode, l1_prod_group: req.l1_product_group,
      eta: (r && r.estimated_delivery_date) || '', delta: String((r && r.data) || ''), city: (r && r.city) || '',
      serviceable: ok ? 'yes' : 'no', qty: req.qty, sessionid: '', status: 'ACTIVE', phone: '', coco_name: '',
      source: 'Website', nitroid: nitro.NITRO_ID, roamingid: nitro.ROAMING_ID, brandid: 'DFX',
      l5_product_group: req.l5_product_group, l6_product_group: req.l6_product_group, scheduled_delivery: ''
    }, { Authorization: LOG_AUTH }).catch(function () {});
  }

  // ---- the check ----
  var seq = 0, active = '', lastKey = '', editing = false, soon = null;
  function busy(on) {
    all('.pincode-checker').forEach(function (el) { if (on) el.setAttribute('aria-busy', 'true'); else el.removeAttribute('aria-busy'); });
  }
  function check(pin, why) {
    pin = cleanPin(pin);
    if (!pin) return; // anything but 6 digits is ignored, as before
    var req = request(pin), key = JSON.stringify(req);
    if (why === 'auto' && key === lastKey) return; // nothing that changes the answer changed
    lastKey = key; active = pin; editing = false;
    savePin(pin);
    var i = input(); if (i) i.value = pin;
    show('.pincode_error_msg', false); show('.arrives-text', false);
    if (OPERA && why === 'button' && !cfg.skipModal) openModal();
    var my = ++seq;
    busy(true);
    post(SLA_URL, req).then(function (r) {
      if (my !== seq) return; // a newer check started meanwhile: its answer wins
      busy(false);
      var ok = !!r && (r.success === true || r.success === 'true');
      if (ok) UI.success(pin, r); else UI.failure(pin, r && r.message);
      if (ok) try { sessionStorage.setItem('pincode', pin); sessionStorage.setItem('city', r.city || ''); } catch (e) {}
      log(req, r, ok);
    }, function () {
      if (my !== seq) return;
      busy(false);
      UI.failure(pin, 'Delivery is not available in your area!');
    });
  }
  // size or quantity changed: re-check the pincode on screen (not while the shopper is editing it)
  function recheckSoon() {
    clearTimeout(soon);
    soon = setTimeout(function () { if (active && !editing) check(active, 'auto'); }, 150);
  }

  // ---- main pages: first visit, no saved pincode -> pincode from location ----
  function detectLocation() {
    if (!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(function (pos) {
      fetch('https://nominatim.openstreetmap.org/reverse?format=json&lat=' + pos.coords.latitude + '&lon=' + pos.coords.longitude)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var pin = cleanPin(d && d.address && d.address.postcode);
          if (!pin || active) return; // the shopper already gave a pincode meanwhile
          check(pin, 'geo');
          emit('duroflex:pincode-detected', { pincode: pin, source: 'pdp_geolocation' }); // lets open popups fill in
        })
        .catch(function () {});
    }, function () {});
  }

  function init() {
    var i = input();
    if (i) {
      i.addEventListener('input', function () { this.value = this.value.replace(/[^0-9]/g, ''); });
      i.addEventListener('paste', function (e) {
        var t = (e.clipboardData || W.clipboardData).getData('text');
        if (/[^0-9]/.test(t)) e.preventDefault();
      });
      i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(i.value, 'button'); } });
    }
    var btn = D.getElementById('checkPincode');
    if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); check(input() && input().value, 'button'); });
    var chg = D.getElementById('changedPincode');
    if (chg) chg.addEventListener('click', function (e) {
      e.preventDefault();
      seq++; busy(false); // an answer still on its way must not redraw the edit state
      editing = true; active = ''; lastKey = '';
      UI.reset();
      emit('duroflex:pincode-cleared', { reason: 'change' });
    });
    if (OPERA) {
      var close = D.querySelector('.modal_pincode_service_header_close'), ov = D.querySelector('.pincode_service_overlay_block'), m = D.getElementById('pincode_response_modal');
      if (close) close.addEventListener('click', closeModal);
      if (ov) ov.addEventListener('click', closeModal);
      if (m) m.addEventListener('click', function (e) { e.stopPropagation(); });
      var jump = D.getElementById('check_service_opera_btn');
      if (jump) jump.addEventListener('click', function () {
        var t = D.getElementById('pincode_check_title');
        if (t) W.scrollTo({ top: t.getBoundingClientRect().top + W.pageYOffset - 120, behavior: 'smooth' });
      });
    }
    D.addEventListener('dfx:pdp-written', recheckSoon); // dfx-pdp.js: variant / quantity fields rewritten
    D.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('input[name="quantity"]')) recheckSoon();
    }, true);
    // a pincode chosen anywhere else (DuroflexPopup.setPincode -> duroflex:pincode_set)
    W.addEventListener('duroflex:pincode_set', function (e) {
      var pin = cleanPin(e && e.detail && e.detail.pincode);
      if (pin && pin !== active) check(pin, 'external');
    });
    var saved = savedPin();
    if (saved) check(saved, 'load');
    else if (!OPERA) detectLocation();
  }

  W.DfxDelivery = {
    request: request,                                           // for the lead / brochure popups
    check: function (pin) { check(pin, 'external'); },          // for the store drawer
    pincode: function () { return active; }
  };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})();
